<mat-grid-list cols="4" rowHeight="2em">
    <mat-grid-tile *ngFor="let n of nationalities">
        <div style="width: 100%; text-align: left">
            <mat-checkbox [(ngModel)]="model[n]">{{n}}</mat-checkbox>
        </div>
    </mat-grid-tile>
</mat-grid-list>
